export PublicLayout from './public-layout';
export PrivateLayout from './private-layout';



// WEBPACK FOOTER //
// ./src/layouts/index.js